import { FolderTree, FolderTreeItem } from '@/api/model/folderModel'
import type {
  CartDocument,
  CartRecipient,
  Client,
  ConfirmPageInitErrorDatas,
  CorporateInfo,
  DeleteMultiCartDocument,
  DeleteMultiCartRecipient,
  RecipientClientDetail,
  RecipientClientList,
  RecipientMasterOptions,
  RecipientSelectCheckErrors,
  RecipientUserList,
} from '@/api/multi-send-cart/model/multiSendCartModel'

export interface State {
  /** @description 送信カート件数*/
  multiCartsCount: string | number;
  /** @description 送信カート 送信対象テーブルデータ */
  sendCartDocument: CartDocument
  /** @description 送信対象テーブ 削除確認ダイヤログ画面表示フラグ */
  modalDeleteSendDocumentActived: boolean
  /** @description 送信先テーブ 削除確認ダイヤログ画面表示フラグ */
  modalDeleteSendRecipientActived: boolean
  /** @description 送信カートの送信メッセージ */
  sendCartMessage: string
  /** @description 送信カート 送信先テーブルデータ */
  sendCartRecipient: CartRecipient
  /** @description 送信カート 送信先選択画面表示フラグ*/
  modalRecipientSelectActived: boolean
  /** @description 送信カート 全てのデータをクリアする確認ダイヤログ画面表示フラグ*/
  modalClearSendCartActived: boolean
  /** @description 送信カート削除する送信対象*/
  deleteRecipientTarget: DeleteMultiCartRecipient
  /** @description 送信カート削除する送信対象*/
  deleteDocumentTarget: DeleteMultiCartDocument
  /** @description 送信先選択画面　送信先マスタ選択optionsデータ*/
  recipientMasterOptions: RecipientMasterOptions
  /** @description 送信先選択画面　取引先選択リストデータ バックアップ*/
  recipientClientList: RecipientClientList
  /** @description 送信先選択画面　取引先選択リストデータ 表示用*/
  displayClientList: RecipientClientList
  /** @description 送信先選択画面　選択した取引先*/
  selectedClient: Client
  /** @description 送信先選択画面　送信先法人情報*/
  corporateInfo: CorporateInfo
  /** @description 送信先選択画面　送信先担当者情報*/
  recipientUserList: RecipientUserList
  selectedUser: RecipientClientDetail
  /** @description 送信先選択画面　送信先フォルダ情報*/
  recipientFolderTreeList: FolderTree
  /** @description 送信先選択画面　選択した送信先フォルダ*/
  selectedFolderTree: FolderTreeItem
  /** @description 送信先選択画面　チェックエラー*/
  checkErrors: RecipientSelectCheckErrors
  /** @description 送信カート確認画面　送信先チェックのエラーメーセージとレベル*/
  confirmPageInitErrorDatas: ConfirmPageInitErrorDatas
  /** @description 送信完了画面　表示フラグ*/
  modalSendFinishedActived: boolean
  /** @description 送信対象　ソートマック  true:表示　false:非表示*/
  sortColumnExist: boolean
  /** @description 送信先　ソートマック true:表示　false:非表示*/
  sortColumnRecipientExist: boolean
}

const state = (): State => ({
  multiCartsCount: '',
  sendCartDocument: [] as CartDocument,
  modalDeleteSendDocumentActived: false,
  sendCartMessage: '',
  sendCartRecipient: [] as CartRecipient,
  modalRecipientSelectActived: false,
  modalClearSendCartActived: false,
  modalDeleteSendRecipientActived: false,
  deleteRecipientTarget: {} as DeleteMultiCartRecipient,
  deleteDocumentTarget: {} as DeleteMultiCartDocument,
  //step1 送信先マスタを選択
  recipientMasterOptions: [] as RecipientMasterOptions,
  //step2 取引先を選択
  recipientClientList: [] as RecipientClientList,
  displayClientList: [] as RecipientClientList,
  selectedClient: {} as Client,
  //step3 担当者を選択
  corporateInfo: {} as CorporateInfo,
  recipientUserList: [] as RecipientUserList,
  selectedUser: {} as RecipientClientDetail,
  //step4 送信先フォルダを選択
  recipientFolderTreeList: [] as FolderTree,
  selectedFolderTree: {} as FolderTreeItem,
  //チェックエラー
  checkErrors: {
    selected_client_error_message: '',
    selected_user_error_message: '',
    selected_folder_error_message: '',
  },
  modalSendFinishedActived: false,
  confirmPageInitErrorDatas: {} as ConfirmPageInitErrorDatas,
  //ソートマック
  sortColumnExist: false,
  sortColumnRecipientExist: false,
})

export default state
